<template>
  <div class="navbar-item has-dropdown" :class="{ 'is-active': open }">
    <a @click="toggle" :class="[{ 'is-active': open }, `navbar-${type}`]">
      <icon v-if="icon" v-bind="{ icon }"/>
      <span v-if="title" v-text="title"></span>
    </a>
    <div class="navbar-dropdown is-boxed" :class="[{ 'is-right': right }, dropClass]" @click="toggle">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    title: {
      type: Boolean | String,
      default: false,
    },
    type: {
      type: String,
      default: 'link',
      validator: value => ['item', 'link'].includes(value)
    },
    icon: {
      type: Boolean | String,
      default: false,
    },
    iconType: {
      type: String,
      default: 'fas',
      validator: type => ['fas', 'far', 'fab'].includes(type)
    },
    right: {
      type: Boolean,
      default: false,
    },
    dropClass: {
      type: Boolean | String,
      default: false,
    },
    badge: {
      type: Boolean,
      default: false,
    }
  },

  data: () => ({
    open: false,
  }),

  methods: {
    toggle() {
      this.open = !this.open
      this.open ? this.listen() : this.unlisten()
    },
    listen() {
      document.addEventListener('click', this.outside)
    },
    unlisten() {
      document.removeEventListener('click', this.outside)
    },
    outside(event) {
      if (!this.open) return this.unlisten()
      if (event.target !== this.$el && !this.$el.contains(event.target)) {
        return this.toggle()
      }
    }
  },

  beforeDestroy() {
    this.unlisten()
  }
}
</script>
